import { render, staticRenderFns } from "./VeAlignPicker.vue?vue&type=template&id=4eee0eec&scoped=true"
import script from "./VeAlignPicker.vue?vue&type=script&lang=js"
export * from "./VeAlignPicker.vue?vue&type=script&lang=js"
import style0 from "./VeAlignPicker.vue?vue&type=style&index=0&id=4eee0eec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eee0eec",
  null
  
)

export default component.exports